import L from 'leaflet'
import 'leaflet.locatecontrol'
import {GeoSearchControl, JsonProvider, OpenStreetMapProvider} from 'leaflet-geosearch'
import CustomProvider from "./Provider";
import ImageCompare from "image-compare-viewer";


export default class Maps {

    constructor(lng, lat, zoom) {
        this.lng = lng
        this.lat = lat
        this.map = new L.Map('mapReports', {
            center: new L.LatLng(this.lat, this.lng),
            zoom: zoom,
            zoomControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            gestureHandling: true
        })
        this.icon = new L.DivIcon({
            iconSize: new L.Point(40, 57),
            className: 'leaflet-div-icon leaflet-editing-icon creasit-marker',
            iconAnchor: [17, 46],
            popupAnchor: [-3, -45]
        })
        this.marker = null
        this.layerGroup = L.featureGroup()
        this.layerData = []
        this.loader = document.getElementById('loader')
        this.filters = document.getElementById('filters-reports')
        this.mapSide = document.getElementById('mapSide')

        const body = document.querySelector('body')
        if(body.classList.contains('logged-in')) {
            this.mapParams = {
                isPreview: false,
                isPrivate: true,
            }
        } else {
            this.mapParams = {
                isPreview: false,
                isPrivate: false,
            }
        }
    }

    /**************
     * Init the map and display it
     *
     ***************/
    get init() {
        // Init the map
        // Source : https://leaflet.github.io/Leaflet.draw/docs/examples/full.html

        let osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            osmAttrib = '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            osm = L.tileLayer(osmUrl, {attribution: osmAttrib});
        osm.addTo(this.map)

        let satelliteView = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            {
                attribution: 'Source: Esri, Maxar, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
            }
        )

        let baseMaps = {
            "<img src='/wp-content/plugins/creasit-reports/assets/dist/front/archive/images/osm.png' />": osm,
            "<img src='/wp-content/plugins/creasit-reports/assets/dist/front/archive/images/satellite.png' />": satelliteView
        }

        L.control.layers(baseMaps, null, {position: 'bottomright'}).addTo(this.map);

        L.Icon.Default.prototype.options.iconUrl = 'creasit-marker.png'
        L.Icon.Default.prototype.options.iconSize = [40, 57]
        L.Icon.Default.prototype.options.iconRetinaUrl = ''

        L.control.zoom({
            position: 'bottomright',
            zoomInTitle: 'Zoomer',
            zoomOutTitle: 'Dézoomer'
        }).addTo(this.map)

        let provider = new CustomProvider()

        let searchControl = new GeoSearchControl({

            position: 'topright',
            style: 'button',
            showMarker: true,
            showPopup: false,
            popupFormat: ({query, result}) => '<div class="geo-search">' + result.label + '</div>',
            // popupFormat: ({result}) => `${result.label}`,
            // resultFormat: ({result}) => `${result.label}`,
            marker: {
                icon: L && L.Icon ? new L.Icon.Default() : undefined,
                draggable: false,
            },
            maxMarkers: 1,
            maxSuggestions: 5,
            retainZoomLevel: true,
            animateZoom: true,
            searchLabel: "Rechercher une adresse",
            notFoundMessage: "Aucun résultat à cette adresse",
            // messageHideDelay: 3000,
            zoomLevel: 30,
            classNames: {
                container: 'leaflet-bar leaflet-control leaflet-control-geosearch',
                button: 'leaflet-bar-part leaflet-bar-part-single',
                resetButton: 'reset',
                msgbox: 'leaflet-bar message',
                form: '',
                input: '',
            },
            // autoComplete: true,
            // autoCompleteDelay: 250,
            // autoClose: false,
            // keepResult: false,
            // updateMap: true,
            provider: provider,
        })

        console.log(searchControl)

        this.map.addControl(searchControl)

        this.map.on('geosearch/showlocation', function (event) {
            this.flyToBounds(event.location.bounds, {
                padding: [100, 100]
            })
        })

        L.control.locate({
                position: 'topright',
                showPopup: false,
                markerClass: L.marker,
                keepCurrentZoomLevel: true,
                drawCircle: false,
                icon: 'fa fa-crosshairs',
                flyTo: true,
                strings: {
                    title: "Indiquer ma position",
                },
                locateOptions: {
                    maxZoom: 15
                },
            }
        ).addTo(this.map);

        this.map.addLayer(this.layerGroup)

        this.layerGroup.on("click",  (event) => {
            let maarkers = document.querySelectorAll('.creasit-marker')
            maarkers.forEach((marker) => {
                marker.classList.remove('active-marker')
            })
            event.layer._icon.classList.add('active-marker')
            this.displayPopup(event.layer._popup._content);
        });
    }

    /**************
     * Add markers on map, by selected terms
     ***************/
    addMarkers(open = false) {
        // Init the PostsQuery Class
        let Query = new PostsQuery()

        // Set the custom creasit api route
        Query._APIRoute = 'reports'

        // Get API endpoint (= url)
        let URL = Query.getURL(this.mapParams);

        // Display loader
        this.loader.classList.add('load')
        if (this.filters !== null) {
            this.filters.classList.add('load')
        }
        console.log(URL)
        Query.fetchAPI(URL, 'GET').then(
            data => {
                console.log(data)
                this.layerGroup.clearLayers()
                this.resetPopup()
                this.createMarker(data, open)
                this.map.flyToBounds(this.layerGroup, {
                    padding: [100, 100]
                })

                if (this.filters !== null) {
                    this.filters.classList.remove('load')
                }
            }
        ).catch(err => {
            // TODO handle error to send
            console.log(err)
        })
    }

    createMarker(data, open = false) {
        data.forEach((element) => {
            // Get marker coordinates
            const mapElements = JSON.parse(element.details.place.marker);

            // Construct marker popup with all infos (do another function to get these infos ?)
            let contentPopup = '<div class="report-popup">'
            if(element.details.image && element.state.image ){
                contentPopup += '<div id="image-compare" class="report-popup__image-wrapper">'

                contentPopup += '<img src="' + element.details.image.sizes.large + '" />'
                contentPopup += '<img src="' + element.state.image.sizes.large + '" />'
                contentPopup += '</div>'
            }
            else if(element.details.image || element.state.image){
                if(element.details.image){
                    contentPopup += '<div class="report-popup__image-wrapper before">'
                    contentPopup += '<img src="' + element.details.image.sizes.large + '"  alt="' + element.details.image.alt + '" />'
                    contentPopup += '</div>'
                }
                else{
                    contentPopup += '<div class="report-popup__image-wrapper after">'
                    contentPopup += '<img src="' + element.state.image.sizes.large + '"  alt="' + element.state.image.alt + '" />'
                    contentPopup += '</div>'
                }
            }
            contentPopup += '<span class="report-popup__category">' + element.terms[0].name + '</span>'
            contentPopup += '<div class="report-popup__details-group">'
            contentPopup += '<h3 class="report-popup__title">Détails du signalement</h3>'
            if (element.details.place.address_group.address ||  element.details.place.address_group.zipcode || element.details.place.address_group.city) {
                contentPopup += '<div class="report-popup__location">'
                contentPopup += '<p class="report-popup__address">' + element.details.place.address_group.address + ', ' + element.details.place.address_group.zipcode + ' ' + element.details.place.address_group.city + '</p>'
                contentPopup += '</div>'
            }
            // If ACF Parameters reports_display_details true
            let $detailsTrue = document.querySelector('.js-has-details')
            if (element.details.details && $detailsTrue) {
                contentPopup += '<p class="report-popup__details">' + element.details.details + '</p>'
            }
            contentPopup += '</div>'
            contentPopup += '<div class="report-popup__state">'
            contentPopup += '<h3 class="report-popup__title">Statut du signalement</h3>'
            contentPopup += '<p class="report-popup__date">' + element.state.date + '</p>'
            let status = element.state.status === "in_process" ? 'En cours de traitement' : element.state.status === "processed" ? 'Traité' : 'Traitement impossible'
            contentPopup += '<p class="report-popup__status ' + element.state.status + '">' + status + '</p>'
            // If ACF Parameters reports_display_details_state true
            let $detailsStateTrue = document.querySelector('.js-has-details-state')
            if(element.state.details && $detailsStateTrue) {
                contentPopup += '<p class="report-popup__stateDetails">' + element.state.details + '</p>'
            }
            contentPopup += '</div>'
            contentPopup += '</div>'


            new L.GeoJSON(mapElements, {
                // Init marker points
                pointToLayer: (feature, latlng) => {
                    let className = open ? 'leaflet-div-icon leaflet-editing-icon creasit-marker active-marker ' + element.state.status : 'leaflet-div-icon leaflet-editing-icon creasit-marker ' + element.state.status
                    return new L.Marker(latlng, {
                        icon: new L.DivIcon({
                            iconSize: new L.Point(40, 57),
                            className: className,
                            iconAnchor: [17, 46],
                            popupAnchor: [-3, -45]
                        }),
                        draggable: false,
                    });
                },
                onEachFeature: (feature, layer) => {
                    layer.bindPopup(contentPopup, {maxWidth: 399})
                    if(open) this.displayPopup(contentPopup)
                    this.layerData.push(layer)
                    this.layerGroup.addLayer(layer)
                },
            })


            //this.map.addLayer(marker)

        })
        this.loader.classList.remove('load')
    }

    displayPopup(contentPopup){
        document.getElementById('mapSide').innerHTML = contentPopup

        const sliderElement = document.getElementById("image-compare");
        if(sliderElement) {
            const sliderOptions = {
                addCircle: true,
                showLabels: true,
                labelOptions: {
                    before: 'Avant',
                    after: 'Après',
                }
            }
            const viewer = new ImageCompare(sliderElement, sliderOptions)
            viewer.mount()
        }
    }

    resetPopup(){
        document.getElementById('mapSide').innerHTML = '<p class="description">Cliquez sur un marqueur pour afficher les détails et le statut d’un signalement.</p>'
    }
}
